__turbopack_context__.v({
  "IsFullWidth": "Video-module-scss-module__9HFPSW__IsFullWidth",
  "IsModal": "Video-module-scss-module__9HFPSW__IsModal",
  "Placeholder": "Video-module-scss-module__9HFPSW__Placeholder",
  "PlayerModal": "Video-module-scss-module__9HFPSW__PlayerModal",
  "ReactPlayer": "Video-module-scss-module__9HFPSW__ReactPlayer",
  "ReactPlayerWrapper": "Video-module-scss-module__9HFPSW__ReactPlayerWrapper",
  "Video": "Video-module-scss-module__9HFPSW__Video",
});
